import React from 'react';
import { Popover, Tag } from 'antd';
import styled from 'styled-components';

import { CorpGroup, CorpUser } from '../../../../../types.generated';
import { useTranslation } from '../../../../../i18n/useTranslation';
import { ExpandedActor } from './ExpandedActor';

const PopoverActors = styled.div`
    max-width: 600px;
`;

const StyledTag = styled(Tag)`
    cursor: pointer;
`;

const ActorsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: right;
`;

type Props = {
    max: number;
    actors: Array<CorpUser | CorpGroup>;
    onClose?: (actor: CorpUser | CorpGroup) => void;
    containerStyle?: any;
};

const DEFAULT_MAX = 10;

export const ExpandedActorGroup = ({ actors, max = DEFAULT_MAX, onClose, containerStyle }: Props) => {
    const { t } = useTranslation();
    const finalActors = actors.length > max ? actors.slice(0, max) : actors;
    const remainder = actors.length > max ? actors.length - max : undefined;
    const remainderActors = actors.length > max ? actors.slice(max) : [];

    return (
        <ActorsContainer style={containerStyle}>
            {finalActors.map((actor) => (
                <ExpandedActor key={actor.urn} actor={actor} onClose={() => onClose?.(actor)} />
            ))}
            {remainder && (
                <Popover
                    trigger={['hover', 'click', 'focus']}
                    placement="topRight"
                    autoAdjustOverflow
                    getPopupContainer={() => document.body}
                    overlayStyle={{
                        zIndex: 1060,
                        maxWidth: 200,
                    }}
                    content={
                        <PopoverActors>
                            {remainderActors.map((actor) => (
                                <ExpandedActor key={actor.urn} actor={actor} onClose={() => onClose?.(actor)} />
                            ))}
                        </PopoverActors>
                    }
                >
                    <StyledTag
                        tabIndex={0}
                        role="button"
                        aria-haspopup="true" // for accessibility
                        className="base-tag label-tag ma-0"
                        aria-label={t('Show {{count}} more owners', { count: remainder })}
                    >
                        +{remainder}
                    </StyledTag>
                </Popover>
            )}
        </ActorsContainer>
    );
};
